import * as PO from '@radix-ui/react-popover';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * Panel flotante anclado a un disparador.
 *
 * Se distingue del menú desplegable en que aquí dentro va CONTENIDO —campos,
 * listas con casillas, una paleta—, no una lista de acciones. El menú se cierra
 * al elegir; esto no, porque marcar tres etiquetas son tres decisiones seguidas.
 */
export const Popover = PO.Root;
export const PopoverTrigger = PO.Trigger;

export function PopoverContent({
  children,
  align = 'center',
  className,
}: {
  children: ReactNode;
  align?: 'start' | 'center' | 'end';
  className?: string;
}) {
  return (
    <PO.Portal>
      <PO.Content
        align={align}
        sideOffset={6}
        // `collisionPadding` evita que se salga por el borde en pantallas
        // pequeñas, que es donde se abre pegado al lateral.
        collisionPadding={12}
        className={cn(
          'anim-content z-50 overflow-hidden rounded-lg border border-border',
          'bg-surface shadow-floating',
          className,
        )}
      >
        {children}
      </PO.Content>
    </PO.Portal>
  );
}
